<div class="w-full text-left">
  <app-manual-hero
    eyebrow="คู่มือการใช้งาน"
    [title]="title()"
    subtitle="อ่านได้โดยไม่ต้องเข้าสู่ระบบ — เลือกหัวข้อด้านล่าง"
    [icon]="kind() === 'ev' ? '/icons/ev_station_slate_dark.svg' : '/icons/local_parking_black.svg'"
  >
    <span
      *ngIf="!isLoading() && !error() && items().length"
      class="inline-flex mt-2.5 px-2.5 py-0.5 rounded-full bg-white/10 text-[11px] font-bold text-(--main-color)"
    >
      {{ items().length }} หัวข้อ
    </span>
  </app-manual-hero>

  <div class="relative z-10 -mt-7 space-y-3">
    <!-- Loading skeleton -->
    <ng-container *ngIf="isLoading()">
      <div *ngFor="let _ of [1, 2, 3]" class="guide-card bg-white rounded-2xl flex overflow-hidden">
        <div class="w-24 min-h-[88px] skeleton"></div>
        <div class="flex-1 p-3 space-y-2">
          <div class="h-3.5 w-3/4 rounded skeleton"></div>
          <div class="h-2.5 w-full rounded skeleton"></div>
          <div class="h-2.5 w-1/2 rounded skeleton"></div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="error()" class="guide-card bg-white rounded-2xl p-6 text-center">
      <img src="/icons/info_red.svg" alt="" class="w-8 h-8 mx-auto mb-2" />
      <p class="text-sm font-bold text-rose-600 m-0">{{ error() }}</p>
      <button
        type="button"
        (click)="load(kind())"
        class="mt-3 px-4 h-9 rounded-xl bg-(--main-color) text-slate-900 text-xs font-bold border-0 cursor-pointer"
      >
        ลองใหม่
      </button>
    </div>

    <div
      *ngIf="!isLoading() && !error() && items().length === 0"
      class="guide-card bg-white rounded-2xl p-8 text-center"
    >
      <div class="w-14 h-14 rounded-2xl bg-amber-50 border border-amber-100 flex items-center justify-center mx-auto mb-3">
        <img src="/icons/help_slate.svg" alt="" class="w-7 h-7" />
      </div>
      <p class="text-sm font-bold text-slate-700 m-0">ยังไม่มีคู่มือที่เผยแพร่ในหมวดนี้</p>
      <a routerLink="/manual" class="inline-block mt-3 text-xs font-bold text-amber-600 no-underline">กลับศูนย์ช่วยเหลือ</a>
    </div>

    <ng-container *ngIf="!isLoading()">
      <a
        *ngFor="let item of items(); let i = index"
        [routerLink]="['/manual/guides', kind(), item.slug]"
        class="guide-card bg-white rounded-2xl flex items-stretch overflow-hidden no-underline text-inherit"
      >
        <div class="w-24 shrink-0 bg-slate-100 relative">
          <img
            *ngIf="item.coverImage; else noCover"
            [src]="item.coverImage"
            [alt]="item.titleTh"
            class="w-full h-full object-cover min-h-[88px]"
          />
          <ng-template #noCover>
            <div class="w-full h-full min-h-[88px] flex items-center justify-center bg-amber-50">
              <img
                [src]="kind() === 'ev' ? '/icons/ev_station_slate_dark.svg' : '/icons/local_parking_black.svg'"
                alt=""
                class="w-8 h-8 opacity-60"
              />
            </div>
          </ng-template>
          <span
            class="absolute left-1.5 top-1.5 min-w-[22px] h-[22px] px-1 rounded-full bg-(--header-background) text-(--main-color) text-[11px] font-extrabold flex items-center justify-center"
          >
            {{ i + 1 }}
          </span>
        </div>
        <div class="min-w-0 flex-1 py-3 px-3 flex flex-col justify-center">
          <p class="text-sm font-extrabold text-slate-800 leading-snug m-0">{{ item.titleTh }}</p>
          <p *ngIf="item.summaryTh" class="text-[11px] text-slate-500 font-medium m-0 mt-1 line-clamp-2">
            {{ item.summaryTh }}
          </p>
        </div>
        <div class="flex items-center pr-3">
          <img src="/icons/chevron_right_slate.svg" alt="" class="w-5 h-5 opacity-50" />
        </div>
      </a>
    </ng-container>
  </div>
</div>
